'use strict';

/*global app*/
/*global services*/

function SectorService() {
  this.$container = null;
  this.modal = null;
  this.data = null;

  this.init();
}

SectorService.prototype = $.extend({}, {
  constructor: 'SectorService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.sector-service__select', function () {
      _this.doSelectSector($(this).data('sector_id'));
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  doSelectSector: function doSelectSector(sectorId) {
    var _this = this;

    _this.modal.close(function () {
      _this.data.callback(sectorId);
    });

    return _this;
  },

  selectSector: function selectSector(data, callback) {
    var _this = this;

    data = data || { title: '' };
    data.callback = callback;

    _this.data = data;
    _this.modal.open({
      modalClass: 'sector-service',
      title: data.title || app.t('sector.title'),
      height: 'auto',
      width: 'md',
      form: false
    }).block();

    $.get(app.path('sector_select'), function (res) {
      _this.modal.unBlock();
      _this.modal.content(res.data.html);
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');
    _this.modal = services.get('modal-input');

    _this.registerCallbacks();

    return _this;
  }
});
